import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface ClickableInvoiceNumberProps {
  invoiceNumber: string;
  invoiceId: number;
  type: 'sales' | 'purchase' | 'payment' | 'payment-out';
  className?: string;
}

export function ClickableInvoiceNumber({ 
  invoiceNumber, 
  invoiceId, 
  type,
  className 
}: ClickableInvoiceNumberProps) {
  const navigate = useNavigate();

  const getRoute = () => {
    switch (type) {
      case 'sales':
        return `/sales-invoices/detail/${invoiceId}`;
      case 'purchase':
        return `/purchase-invoices/detail/${invoiceId}`;
      case 'payment':
        return `/payments-in/detail/${invoiceId}`;
      case 'payment-out':
        return `/payments-out/detail/${invoiceId}`;
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Support Ctrl/Cmd+Click to open in new tab
    if (e.ctrlKey || e.metaKey) {
      window.open(getRoute(), '_blank');
    } else {
      navigate(getRoute());
    }
  };

  return (
    <a
      href={getRoute()}
      onClick={handleClick}
      className={cn(
        "text-primary hover:text-primary/80 hover:underline cursor-pointer transition-colors",
        "visited:text-primary/70",
        className
      )}
    >
      {invoiceNumber}
    </a>
  );
}